import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';
import ConsultationWrapper from './components/ConsultationWrapper';
import routes from './components/pages/index';

// Admin Pages
import AdminLogin from './components/pages/AdminLogin';
import Dashboard from './components/admin/Dashboard';
import BlogManagement from './components/admin/BlogManagement';
import TeamManagement from './components/admin/TeamManagement';
import ServicesManagement from './components/admin/ServicesManagement';
import ContactsManagement from './components/admin/ContactsManagement';
import TestimonialsManagement from './components/admin/TestimonialsManagement';
import CaseStudiesManagement from './components/admin/CaseStudiesManagement';
import BrochuresManagement from './components/admin/BrochuresManagement';
import Settings from './components/admin/Settings';
import Analytics from './components/admin/Analytics';
import AuditLogs from './components/admin/AuditLogs';
import useAnalytics from './analytics/useAnalytics';
import SEO from './components/seo/SEO';

// User Pages
import UserLogin from './components/pages/UserLogin';
import Contact01 from './components/pages/Contact01';

function App() {
  const renderPublicRoute = (data) => {
    const Page = data.component;
    return (
      <>
        {data.seo && <SEO path={data.path} {...data.seo} />}
        <Page />
      </>
    );
  };

  return (
    <AuthProvider>
      <BrowserRouter>
        {/* Mount analytics inside Router context */}
        {(() => {
          const AnalyticsMount = () => { useAnalytics(); return null; };
          return <AnalyticsMount />;
        })()}
        <Routes>
          {/* Public Routes */}
          {routes.map((data, idx) => (
            <Route key={idx} path={data.path} element={renderPublicRoute(data)} />
          ))}

          {/* User Routes */}
          <Route path="/user-login" element={<><SEO title="Client Login | Stats Elite" description="Sign in to request consultations and manage Stats Elite advisory conversations." path="/user-login" robots="noindex,nofollow" /><UserLogin /></>} />

          {/* Consultation Route (requires user authentication) */}
          <Route
            path="/consultation"
            element={
              <ConsultationWrapper>
                <SEO title="Request a Consultation | Stats Elite" description="Request a Stats Elite consultation for data consulting, MERL, statistics, analytics, or training support." path="/consultation" robots="noindex,nofollow" />
                <Contact01 />
              </ConsultationWrapper>
            }
          />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<><SEO title="Admin Login | Stats Elite" description="Stats Elite administrator login." path="/admin/login" robots="noindex,nofollow" /><AdminLogin /></>} />

          {/* Protected Admin Routes */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <SEO title="Admin | Stats Elite" description="Stats Elite administrator workspace." path="/admin" robots="noindex,nofollow" />
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/blog" element={<BlogManagement />} />
                  <Route path="/team" element={<TeamManagement />} />
                  <Route path="/services" element={<ServicesManagement />} />
                  <Route path="/contacts" element={<ContactsManagement />} />
                  <Route path="/testimonials" element={<TestimonialsManagement />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/audit-logs" element={<AuditLogs />} />
                  <Route path="/case-studies" element={<CaseStudiesManagement />} />
                  <Route path="/brochures" element={<BrochuresManagement />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
                </Routes>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
